export const API_MC_MODES = ["reshuffle", "bootstrap", "subsample"];
export const API_BOOK_PARTITIONS = [
    "scan_outcomes",
    "decisions",
    "positions",
    "movements",
    "settlements",
    "nav",
    "exposures",
    "coverage",
    "controls",
    "realized_reconciliation",
];
export const JOB_TYPE_NAMES = [
    "backtest",
    "optimization",
    "live",
    "cache",
    "walk_forward",
    "monte_carlo",
    "scan",
    "book",
];
export const JOB_STATUS_NAMES = [
    "queued",
    "claimed",
    "running",
    "completed",
    "failed",
    "cancelled",
    "paused",
];
export const API_SAME_CANDLE_REENTRY_MODES = ["off", "market", "evidence"];
export const API_SAME_CANDLE_REENTRY_UNRESOLVED = ["skip", "error"];
export const API_CROSS_DIRECTION_REVERSAL_POLICIES = ["legacy", "symmetric"];
